import React, { useState } from 'react';

const VendaPremiumPage = ({ onVoltar }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="font-sans text-gray-900 bg-white overflow-x-hidden">
      <section className="relative min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-white via-purple-50 to-purple-100 px-4 sm:px-6 lg:px-8 pt-10 pb-20 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-300 opacity-30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-yellow-400 opacity-20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
        <div className="relative z-10 max-w-5xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center gap-2 bg-purple-100 border border-purple-200 rounded-full px-4 py-1.5 shadow-sm animate-fade-in-up">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-trophy w-4 h-4 text-purple-800" aria-hidden="true">
              <path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978"></path>
              <path d="M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978"></path>
              <path d="M18 9h1.5a1 1 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path d="M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z"></path>
              <path d="M6 9H4.5a1 1 0 0 1 0-5H6"></path>
            </svg>
            <span className="text-sm font-medium text-purple-800 uppercase tracking-wide">Método Comprovado Vestibula</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight tracking-tight">Pare de estudar sem rumo! <br/><span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-purple-600">Transforme seus resultados</span></h1>
          <p className="text-xl md:text-2xl text-gray-600 font-semibold max-w-3xl mx-auto">Cronograma personalizado + Acompanhamento de progresso + Flashcards inteligentes = <span className="text-purple-800 underline decoration-yellow-400 decoration-4 underline-offset-4">Mais chances de aprovação</span></p>
          <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="group relative bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold text-lg md:text-xl px-10 py-5 rounded-full shadow-[0_4px_14px_0_rgba(255,215,0,0.39)] transition-all duration-300 transform hover:scale-105 flex items-center gap-3">Comece sua transformação AGORA
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right w-6 h-6 group-hover:translate-x-1 transition-transform" aria-hidden="true">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </button>
          </div>
          <p className="text-sm text-gray-500 font-medium">🔒 Garantia de 7 dias ou seu dinheiro de volta</p>
        </div>
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce text-purple-600/50">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-down" aria-hidden="true">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">Isso soa familiar para você?</h2>
            <p className="mt-4 text-xl text-gray-600">A maioria dos estudantes falha não por falta de capacidade, mas por falta de <span className="font-bold text-red-500">estratégia</span>.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow duration-300 group">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-trending-down w-8 h-8 text-red-500" aria-hidden="true">
                  <path d="M16 17h6v-6"></path>
                  <path d="m22 17-8.5-8.5-5 5L2 7"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Estuda muito, zero resultado?</h3>
              <p className="text-gray-600 leading-relaxed">Passa horas nos livros, mas sente que não absorve nada e as notas não sobem.</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow duration-300 group">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-clock w-8 h-8 text-red-500" aria-hidden="true">
                  <path d="M12 6v6l4 2"></path>
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Perdendo tempo?</h3>
              <p className="text-gray-600 leading-relaxed">Sente que está gastando energia com conteúdo aleatório que nem cai na prova.</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow duration-300 group">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map w-8 h-8 text-red-500" aria-hidden="true">
                  <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"></path>
                  <path d="M15 5.764v15"></path>
                  <path d="M9 3.236v15"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sem direção?</h3>
              <p className="text-gray-600 leading-relaxed">Não sabe por onde começar, o que priorizar ou qual matéria estudar hoje.</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow duration-300 group">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-triangle-alert w-8 h-8 text-red-500" aria-hidden="true">
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
                  <path d="M12 9v4"></path>
                  <path d="M12 17h.01"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sem constância?</h3>
              <p className="text-gray-600 leading-relaxed">Começa empolgado na segunda-feira, mas desiste na quarta por falta de organização.</p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-purple-900 text-white overflow-hidden relative">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
            <div className="mb-12 lg:mb-0">
              <div className="inline-flex items-center gap-2 bg-purple-700/30 border border-purple-300/20 rounded-full px-4 py-1.5 mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-sparkles w-4 h-4 text-yellow-400" aria-hidden="true">
                  <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
                  <path d="M20 2v4"></path>
                  <path d="M22 4h-4"></path>
                  <circle cx="4" cy="20" r="2"></circle>
                </svg>
                <span className="text-sm font-medium text-purple-200 uppercase">A Solução Definitiva</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight">O Plano Premium da Vestibula resolve todos esses problemas com <span className="text-yellow-400">tecnologia de ponta</span></h2>
              <p className="text-purple-200 text-lg mb-8 leading-relaxed">Esqueça planilhas manuais e cronogramas genéricos. Nosso sistema aprende com você e garante que cada minuto de estudo conte para a sua aprovação.</p>
              <ul className="space-y-6">
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-purple-700 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-brain w-6 h-6 text-white" aria-hidden="true">
                      <path d="M12 18V5"></path>
                      <path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"></path>
                      <path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                      <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                      <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                      <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                      <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                      <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                    </svg>
                  </div>
                  <span className="text-lg font-medium pt-1">Sistema inteligente que se adapta ao seu ritmo e estilo de aprendizagem</span>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-purple-700 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-target w-6 h-6 text-white" aria-hidden="true">
                      <circle cx="12" cy="12" r="10"></circle>
                      <circle cx="12" cy="12" r="6"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                    </svg>
                  </div>
                  <span className="text-lg font-medium pt-1">Focado 100% em resultados reais para vestibulares e ENEM</span>
                </li>
                <li className="flex items-start">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-purple-700 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-check-big w-6 h-6 text-white" aria-hidden="true">
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                      <path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <span className="text-lg font-medium pt-1">Tecnologia de repetição espaçada para memorização permanente</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 bg-yellow-400 opacity-20 blur-xl rounded-full"></div>
              <img alt="Estudante feliz usando a plataforma Vestibula" className="relative rounded-2xl shadow-2xl border-4 border-purple-700/30 transform rotate-2 hover:rotate-0 transition-all duration-500" src="/estudantevestibula.png"/>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">Resultados baseados em evidências científicas</h2>
            <p className="text-lg text-gray-600">Não utilizamos números inventados. Nosso método é fundamentado nas descobertas mais sólidas da neurociência da aprendizagem.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-b-4 border-purple-900 hover:-translate-y-2 transition-transform duration-300">
              <div className="text-purple-900 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-brain w-12 h-12" aria-hidden="true">
                  <path d="M12 18V5"></path>
                  <path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"></path>
                  <path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                  <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                  <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                  <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                  <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                  <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                </svg>
              </div>
              <div className="text-5xl font-bold text-gray-900 mb-2">96%<span className="text-2xl text-gray-400">eficácia</span></div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Retenção de Longo Prazo</h3>
              <p className="text-gray-600">Revisões espaçadas melhoram significativamente a retenção de informação em comparação com métodos tradicionais em 96% dos estudos analisados.</p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-b-4 border-yellow-400 hover:-translate-y-2 transition-transform duration-300 relative overflow-hidden">
              <div className="absolute top-0 right-0 bg-yellow-400 text-xs font-bold px-3 py-1 rounded-bl-lg">CIÊNCIA</div>
              <div className="text-yellow-600 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-graduation-cap w-12 h-12" aria-hidden="true">
                  <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path>
                  <path d="M22 10v6"></path>
                  <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                </svg>
              </div>
              <div className="text-5xl font-bold text-gray-900 mb-2">Nota<span className="text-2xl text-gray-400">máxima</span></div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Desempenho em Avaliações</h3>
              <p className="text-gray-600">Estudantes que utilizam práticas de recuperação espaçada consistentemente superam seus pares em avaliações de cursos de matemática e ciências.</p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-b-4 border-green-500 hover:-translate-y-2 transition-transform duration-300">
              <div className="text-green-500 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-book-open w-12 h-12" aria-hidden="true">
                  <path d="M12 7v14"></path>
                  <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
                </svg>
              </div>
              <div className="text-5xl font-bold text-gray-900 mb-2">100%<span className="text-2xl text-gray-400">validado</span></div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Fundamentação Sólida</h3>
              <p className="text-gray-600">O efeito do espaçamento é um dos achados mais sólidos da ciência da aprendizagem, validado por décadas de pesquisa sobre memória humana.</p>
            </div>
          </div>
        </div>
      </section>
      
      
      <section className="bg-gradient-to-r from-purple-900 to-purple-800 py-10 px-4">
        <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8 border border-white/20 shadow-2xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-white">
            <div className="flex items-center gap-4">
              <div className="bg-red-500/20 p-3 rounded-full animate-pulse">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-timer w-8 h-8 text-red-400" aria-hidden="true">
                  <line x1="10" x2="14" y1="2" y2="2"></line>
                  <line x1="12" x2="15" y1="14" y2="11"></line>
                  <circle cx="12" cy="14" r="8"></circle>
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-xl text-red-300 uppercase tracking-wider">Atenção: Oferta Limitada</h3>
                <p className="text-purple-100">Desconto de 50% para os primeiros alunos</p>
              </div>
            </div>
            <div className="flex items-center gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold font-mono">100</div>
                <div className="text-xs uppercase text-purple-200">Vagas Totais</div>
              </div>
              <div className="h-10 w-px bg-purple-500/50"></div>
              <div className="text-center">
                <div className="text-3xl font-bold font-mono text-yellow-400">14</div>
                <div className="text-xs uppercase text-purple-200">Restantes</div>
              </div>
            </div>
          </div>
          <div className="mt-6 bg-black/20 rounded-full h-4 overflow-hidden">
            <div className="bg-gradient-to-r from-red-500 to-yellow-500 h-full w-[86%] rounded-full shadow-[0_0_10px_rgba(255,193,7,0.5)]"></div>
          </div>
          <p className="text-center text-sm text-purple-200 mt-2 flex items-center justify-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-users" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <circle cx="9" cy="7" r="4"></circle>
            </svg> 14 pessoas estão comprando o plano neste momento.
          </p>
        </div>
      </section>
      
      <section className="bg-purple-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="inline-block bg-white p-6 rounded-full shadow-lg mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-shield-check w-16 h-16 text-green-500" aria-hidden="true">
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Garantia Incondicional de 7 Dias</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">Teste o Vestibula Premium sem riscos. Se você não ver evolução nos seus estudos na primeira semana, devolvemos 100% do seu dinheiro. Sem burocracia, sem perguntas.</p>
          <div className="flex flex-wrap justify-center gap-4 opacity-70 grayscale hover:grayscale-0 transition-all duration-500">
            <div className="bg-white px-4 py-2 rounded border border-gray-200 font-bold text-gray-500">Compra Segura SSL</div>
            <div className="bg-white px-4 py-2 rounded border border-gray-200 font-bold text-gray-500">Suporte 24/7</div>
            <div className="bg-white px-4 py-2 rounded border border-gray-200 font-bold text-gray-500">Acesso quase imediato</div>
          </div>
        </div>
      </section>
      
      <section id="pricing" className="py-24 bg-white relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Invista no seu futuro por menos de um lanche</h2>
            <p className="text-xl text-gray-600">Escolha o plano que melhor se adapta à sua jornada.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center max-w-5xl mx-auto">
            <div className="relative bg-white rounded-3xl p-8 transition-all duration-300 border border-gray-200 shadow-lg hover:shadow-xl">
              <h3 className="text-xl font-semibold text-gray-600 mb-4">Semestral</h3>
              <div className="flex items-baseline mb-8">
                <span className="text-sm text-gray-500 mr-1">R$</span>
                <span className="text-5xl font-bold text-purple-900">6,49</span>
                <span className="text-sm text-gray-500 ml-1">/mês</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acesso completo
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Cronograma 100% personalizado
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Revisão Ilimitada de flashcards
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acompanhamento de progresso
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Simulador de Nota do ENEM (TRI)
                </li>
              </ul>
              <a href="https://pay.hotmart.com/L103933592N?off=n1pq9y10" target="_blank" rel="noopener noreferrer">
                <button className="w-full py-4 rounded-xl font-bold text-lg transition-colors duration-200 bg-gray-100 text-gray-900 hover:bg-gray-200">Assinar Semestral</button>
              </a>
              <div className="text-center mt-2 text-sm text-gray-500">2x de R$ 19,50</div>
            </div>
            
            <div className="relative bg-white rounded-3xl p-8 transition-all duration-300 border-2 border-purple-900 shadow-[0_0_40px_rgba(123,44,219,0.2)] transform md:-translate-y-4 z-10">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-purple-900 text-white px-6 py-2 rounded-full text-sm font-bold tracking-wider uppercase shadow-lg">MAIS POPULAR</div>
              <h3 className="text-xl font-semibold text-gray-600 mb-4">Anual</h3>
              <div className="flex items-baseline mb-8">
                <span className="text-sm text-gray-500 mr-1">R$</span>
                <span className="text-5xl font-bold text-purple-900">4,99</span>
                <span className="text-sm text-gray-500 ml-1">/mês</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-purple-100 text-purple-900">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acesso completo
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-purple-100 text-purple-900">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Cronograma 100% personalizado
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-purple-100 text-purple-900">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Revisão Ilimitada de flashcards
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-purple-100 text-purple-900">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acompanhamento de progresso
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-purple-100 text-purple-900">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Simulador de Nota do ENEM (TRI)
                </li>
              </ul>
              <a href="https://pay.hotmart.com/L103933592N?off=jn402den" target="_blank" rel="noopener noreferrer">
                <button className="w-full py-4 rounded-xl font-bold text-lg transition-colors duration-200 bg-purple-900 text-white hover:bg-purple-700 shadow-lg hover:shadow-purple-500/30">Assinar Anual</button>
              </a>
              <div className="text-center mt-2 text-sm text-gray-500">3x de R$ 19,99</div>
            </div>

            <div className="relative bg-white rounded-3xl p-8 transition-all duration-300 border border-gray-200 shadow-lg hover:shadow-xl">
              <h3 className="text-xl font-semibold text-gray-600 mb-4">Trimestral</h3>
              <div className="flex items-baseline mb-8">
                <span className="text-sm text-gray-500 mr-1">R$</span>
                <span className="text-5xl font-bold text-purple-900">8,33</span>
                <span className="text-sm text-gray-500 ml-1">/mês</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acesso completo
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Cronograma 100% personalizado
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Revisão Ilimitada de flashcards
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Acompanhamento de progresso
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="p-1 rounded-full mr-3 bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                  </div>
                  Simulador de Nota do ENEM (TRI)
                </li>
              </ul>
              <a href="https://pay.hotmart.com/L103933592N?off=mvi4wolp" target="_blank" rel="noopener noreferrer">
                <button className="w-full py-4 rounded-xl font-bold text-lg transition-colors duration-200 bg-gray-100 text-gray-900 hover:bg-gray-200">Assinar Trimestral</button>
              </a>
              <div className="text-center mt-2 text-sm text-gray-500">R$ 24,99</div>
            </div>
          </div>
          <div className="text-center mt-12">
            <p className="text-red-500 font-medium animate-pulse">Evite perder mais um ano letivo. O custo de não passar é muito maior.</p>
          </div>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">Perguntas Frequentes</h2>
            <p className="mt-2 text-gray-600">Tire suas dúvidas e comece sua transformação.</p>
          </div>
          <div className="space-y-2">
            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleFAQ(0)}
                className="w-full py-6 flex items-center justify-between text-left focus:outline-none group"
              >
                <span className="text-lg font-medium text-gray-900 group-hover:text-purple-900 transition-colors">Quantos minutos por dia preciso dedicar?</span>
                <div className="p-2 rounded-full transition-colors bg-gray-100 text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-chevron-down transition-transform duration-300 ${openIndex === 0 ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 0 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-gray-600 leading-relaxed pr-8 pb-6">O cronograma de estudos é 100% personalizado e se adequa à sua rotina, seja ela qual for. Você define quanto tempo tem disponível e nosso sistema otimiza seus estudos para caber nesse período.</p>
              </div>
            </div>
            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleFAQ(1)}
                className="w-full py-6 flex items-center justify-between text-left focus:outline-none group"
              >
                <span className="text-lg font-medium text-gray-900 group-hover:text-purple-900 transition-colors">Tenho dificuldades em organização, vai funcionar pra mim?</span>
                <div className="p-2 rounded-full transition-colors bg-gray-100 text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-chevron-down transition-transform duration-300 ${openIndex === 1 ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 1 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-gray-600 leading-relaxed pr-8 pb-6">Com certeza! A plataforma resolve exatamente isso com um sistema de notificações inteligentes que te avisa o que revisar na hora certa, além de um cronograma claro que diz exatamente o que estudar a cada dia.</p>
              </div>
            </div>
            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleFAQ(2)}
                className="w-full py-6 flex items-center justify-between text-left focus:outline-none group"
              >
                <span className="text-lg font-medium text-gray-900 group-hover:text-purple-900 transition-colors">Preciso de computador ou posso usar só o celular?</span>
                <div className="p-2 rounded-full transition-colors bg-gray-100 text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-chevron-down transition-transform duration-300 ${openIndex === 2 ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 2 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-gray-600 leading-relaxed pr-8 pb-6">Funciona perfeitamente em qualquer dispositivo. Você pode estudar no ônibus, na fila do banco ou no conforto do seu quarto.</p>
              </div>
            </div>
            <div className="border-b border-gray-200">
              <button
                onClick={() => toggleFAQ(3)}
                className="w-full py-6 flex items-center justify-between text-left focus:outline-none group"
              >
                <span className="text-lg font-medium text-gray-900 group-hover:text-purple-900 transition-colors">O cancelamento é fácil?</span>
                <div className="p-2 rounded-full transition-colors bg-gray-100 text-gray-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`lucide lucide-chevron-down transition-transform duration-300 ${openIndex === 3 ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                  >
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === 3 ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-gray-600 leading-relaxed pr-8 pb-6">Sim, você tem total controle da sua assinatura dentro da plataforma. Sem ligações, sem stress.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="bg-gray-900 text-white pt-20 pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-16 gap-8 text-center md:text-left">
            <div className="max-w-xl">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Sua vaga está esperando.</h2>
              <p className="text-xl text-gray-400">Junte-se a mais de <span className="text-purple-600 font-bold">1.000 alunos</span> que já estudam conosco. Não adie mais o seu sonho.</p>
            </div>
            <div>
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold px-8 py-4 rounded-full text-lg shadow-lg hover:shadow-yellow-400/20 transition-all flex items-center gap-2">Quero ser aprovado
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right" aria-hidden="true">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-purple-900 rounded-lg flex items-center justify-center font-bold text-white">V</div>
              <span className="font-bold text-lg tracking-tight">Vestibula</span>
            </div>
            <div className="text-gray-500 text-sm">© 2024 Vestibula. Todos os direitos reservados.</div>
          </div>
        </div>
      </footer>
      
      <div className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-5px_20px_rgba(0,0,0,0.1)] z-50 md:hidden animate-slide-up">
        <div className="flex items-center justify-between gap-4 max-w-md mx-auto">
          <div className="flex flex-col">
            <span className="text-xs text-gray-500 font-medium">Oferta limitada</span>
            <span className="text-lg font-bold text-purple-900">3x de R$ 19,99</span>
            <span className="text-xs text-gray-500 line-through">R$ 59,97</span>
          </div>
          <a href="https://pay.hotmart.com/L103933592N?off=jn402den" target="_blank" rel="noopener noreferrer">
            <button className="bg-yellow-400 text-gray-900 font-bold px-6 py-3 rounded-xl shadow-lg flex-1">Assinar Agora</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default VendaPremiumPage;